import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.concat.js";

/*----------------------------------------------------*/
// Dependencies

/*----------------------------------------------------*/
import { isElement, cloneDeep as _cloneDeep } from 'lodash';
import { performance, register, attach } from './core';
/*----------------------------------------------------*/
// Constants & Variables

/*----------------------------------------------------*/

var UID = 0;
var PLUGINS = [];
var defaults = {
  priority: 10,
  delay: 0,
  $: Object.create(null),
  $$: Object.create(null)
};
var properties = {
  debug: __DEV__,
  $: Object.create(null),
  $$: Object.create(null),
  promises: Object.create(null),
  timers: Object.create(null),
  bounds: Object.create(null)
};
/*----------------------------------------------------*/
// Module

/*----------------------------------------------------*/

var Controller = /*#__PURE__*/function () {
  function Controller() {
    var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var controller = arguments.length > 1 ? arguments[1] : undefined;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Object.create(null);

    _classCallCheck(this, Controller);

    if (element === null) {
      element = $d(document.body);
    } else if (isElement(element)) {
      element = $d(element);
    }

    this.$element = element;
    this._controller = controller; // options

    this.options = Object.assign(Object.create(null), defaults, options); // properties

    Object.assign(this, _cloneDeep(properties)); // remove useless prototypes

    if (typeof Object.setPrototypeOf !== 'undefined') {
      Object.setPrototypeOf(this.options, null);
      Object.setPrototypeOf(this.options.$, null);
      Object.setPrototypeOf(this.options.$$, null);
    } // controller internal properties


    this._name = options.name || this._name;

    if (typeof this._name === 'undefined') {
      return false;
    }

    UID += 1;
    this._uid = UID;
    this._priority = this.options.priority;
    this._delay = this.options.delay; // attach plugins

    attach(PLUGINS, this);
    return this;
  }

  _createClass(Controller, [{
    key: "init",
    value: function init(options) {
      return this;
    } // Application lifecycles
    // --------------------------------------------------

  }, {
    key: "created",
    value: function created() {
      var resolve = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      // refresh dom objects collection
      this.$select();

      if (resolve === true) {
        return Promise.resolve();
      }

      return true;
    }
    /* eslint-disable class-methods-use-this */

  }, {
    key: "destroy",
    value: function destroy() {}
  }, {
    key: "enter",
    value: function enter() {
      var resolve = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (resolve === true) {
        return Promise.resolve();
      }

      return true;
    }
  }, {
    key: "leave",
    value: function leave() {
      var resolve = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (resolve === true) {
        return Promise.resolve();
      }

      return true;
    }
    /* eslint-enable class-methods-use-this */
    // Helpers
    // --------------------------------------------------

  }, {
    key: "$select",
    value: function $select() {
      this.$ = this.$element.$select(this.options.$);
      this.$$ = this.options.$$;
    } // Static
    // --------------------------------------------------

  }], [{
    key: "cloneDeep",
    value: function cloneDeep() {
      var objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.create(null);
      return _cloneDeep(objects);
    }
  }, {
    key: "use",
    value: function use() {
      var module = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      register.apply(void 0, [PLUGINS, module].concat(args));
    }
  }]);

  return Controller;
}();

export default Controller;

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}